import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/isRestoring.js");
;
import(/* webpackMode: "eager" */ "/gs-website/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/gs-website/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/gs-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/gs-website/src/app/in/(their)/[route]/Wrapper/index.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/landingPage/BreadCrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/gs-website/src/components/landingPage/KeyOutcomes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/gs-website/src/components/new/Common/SectionFixedCard.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/Common/SliderMentorship/index.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/Common/SliderSelfPaced/index.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/Common/SliderWorkshop/index.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/HomePage/SectionAlumni.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/HomePage/SectionCtaCard.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/HomePage/SectionLearners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/gs-website/src/components/new/HomePage/SectionSkinBackground.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/HomePage/SectionTabs.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/HomePage/SectionTestimonials.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/new/HomePage/SectionUpskill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/gs-website/src/components/premiumindustry/IndustryHero/index.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/premiumindustry/SectionMentors/index.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/premiumindustry/SectionNichePick/index.scss");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/premiumindustry/SectionStats/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/gs-website/src/components/premiumSubIndustry/SubIndustryHero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/gs-website/src/components/slp-landing-page/MetaDetails.tsx");
;
import(/* webpackMode: "eager" */ "/gs-website/src/components/slp-landing-page/page.scss");
